import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "accessibility-statement-block"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_editor_viewer = _resolveComponent("editor-viewer");
  return _ctx.accessibilityData ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_editor_viewer, {
    "html-content": _ctx.accessibilityData.statement
  }, null, 8, ["html-content"])])) : _createCommentVNode("", true);
}